import { render } from "./ZeroToTenScale.vue?vue&type=template&id=55c0c3ea&scoped=true"
import script from "./ZeroToTenScale.vue?vue&type=script&lang=js"
export * from "./ZeroToTenScale.vue?vue&type=script&lang=js"

import "./ZeroToTenScale.vue?vue&type=style&index=0&id=55c0c3ea&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\projetos\\ethos-nps\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c0c3ea"]])

export default __exports__